import { TriggeredHook } from "sonobello.utilities.react";

import TriggeredHookContextDecorator from "../../App/Compositions/TriggeredHookContextDecorator";
import useUpsertPatientNote from "../Hooks/useUpsertPatientNote";

/** A hook which create or update patient notes appropriately when triggered with the desired content. */
const ComposedUseUpsertPatientNote: TriggeredHook<unknown, string, boolean> = TriggeredHookContextDecorator(
  useUpsertPatientNote,
  ({ patient, leadIdCState }) => ({
    leadId: leadIdCState,
    patientId: patient.id,
    centerId: patient.centerId
  })
);

export default ComposedUseUpsertPatientNote;
